<template>
  <div class="mb-20 -mt-44 w-full about md:-mt-32 md:mb-8 md:pb-0">
    <div class="flex relative justify-between items-center w-full rounded-2xl shadow">
      <div class="flex hidden relative justify-around items-center mt-16 w-2/12 bg-transparent opacity-70 animate-spin md:inline-flex -z-10">
        <span
          class="transform rotate-90 animate-pulse top-5 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
        <span
          class="transform rotate-105 animate-pulse top-15 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
        <span
          class="transform rotate-180 animate-pulse left-20 lg:left-10 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
        <span
          class="transform -rotate-90 animate-pulse bottom-5 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
        <span
          class="transform rotate-105 animate-pulse right-20 lg:right-10 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
      </div>
      <div class="flex relative flex-col w-full md:w-8/12">
        <div class="flex relative flex-col justify-center items-center">
          <div class="absolute space-x-8 opacity-25 text-icon_muted">
            <i class="text-9xl fas fa-angle-left"></i>
            <i class="text-9xl fas fa-question"></i>
            <i class="text-9xl fas fa-angle-right"></i>
          </div>
          <div class="flex justify-center items-center pb-8 uppercase text-primary"><h3
            class="absolute top-0 text-2xl font-bold tracking-wide lg:text-3xl">About Me</h3></div>
        </div>
        <div class="flex p-8 mt-2 text-primary md:mt-6"><p class="text-sm tracking-wide text-justify md:text-base">
          I am a Software Engineer based in Lagos, Nigeria. I have adept experience in writing maintainable and functional
          code, following best practices, and building software solutions. I value teamwork and respect everyone’s opinion.
          At my leisure time I research, play video games, and learn new technologies, as well as latest development in tech.</p>
        </div>
      </div>
      <div class="flex hidden relative justify-center items-center w-2/12 opacity-40 md:inline-flex">
        <span class="absolute bg-secondary ring-4 -z-10 opacity-70 ring-muted border-2 w-40 h-80 rounded-l-full -right-10 animate-pulse bg-primary border-1.5 border-r-0 shadow-cst_lg border-muted"></span>
      </div>
    </div>
    <div class="w-full bg-primary md:mt-16 lg:mt-32">
      <div class="text-primary">
        <div class="flex justify-between items-center">
          <div class="flex relative left-6 flex-col justify-center mt-1 w-1/12 md:mt-10">
            <div
              class="absolute bottom-40 w-20 h-24 rounded-tl-3xl border-4 border-r-0 border-b-0 border-secondary md:bottom-8"></div>
            <div class="absolute top-80 w-20 h-24 rounded-bl-3xl border-4 border-t-0 border-r-0 border-secondary md:top-48"></div>
          </div>
          <div class="flex flex-col w-full md:w-10/12">
            <div class="flex relative flex-col justify-center items-center mt-12">
              <div class="absolute space-x-2 opacity-30 text-icon_muted">
                <i class="text-9xl fas fa-angle-left"></i>
                <i class="text-8xl transform rotate-90 fas fa-slash"></i>
                <i class="text-9xl fas fa-angle-right"></i>
              </div>
              <div class="flex justify-center items-center pb-8 uppercase text-primary"><h3
                class="absolute top-0 text-xl font-bold tracking-wide md:text-2xl lg:text-3xl">My Skills</h3></div>
            </div>
            <div class="flex flex-wrap justify-between items-center py-12 px-6 mt-14 space-y-8 w-full md:space-y-0 lg:ml-6">
              <div class="mt-8 w-1/2 md:w-auto md:mt-0">
                <ul class="flex flex-col justify-center items-center space-y-1 md:space-y-6 lg:text-lg">
                  <li class="flex justify-center items-center"><i class="mr-2 -ml-5 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4 md:-ml-5"></i><span>PHP</span></li>
                  <li class="flex justify-center items-center"><i class="mr-2 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4"></i><span>Node Js</span></li>
                  <li class="flex justify-center items-center"><i class="mr-2 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4"></i><span>Python</span></li>
                  <li class="flex justify-center items-center"><i class="mr-2 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4"></i><span>jQuery</span></li>
                </ul>
              </div>
              <div class="w-1/2 md:w-auto">
                <ul class="flex flex-col justify-center items-center space-y-1 md:space-y-6 lg:text-lg">
                  <li class="flex justify-center items-center"><i class="mr-2 -ml-12 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4"></i><span>Laravel</span></li>
                  <li class="flex justify-center items-center"><i class="mr-2 -ml-14 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4"></i><span>Vue Js</span></li>
                  <li class="flex justify-center items-center"><i class="mr-2 text-sm -ml-16 fas fa-circle md:text-lg text-secondary lg:mr-4"></i><span>Flask</span></li>
                  <li class="flex justify-center items-center"><i class="mr-2 text-sm fas -ml-1 fa-circle md:text-lg text-secondary lg:mr-4"></i><span>Tailwind CSS</span></li>
                </ul>
              </div>
              <div class="flex flex-col justify-center items-center w-full md:w-48"><img src="../assets/images/personal-photo.jpeg" alt="Portrait Photo" class="object-cover w-48 h-64 opacity-80 rounded-tr-6 rounded-bl-6 shadow-cst_md md:mt-12"></div>
              <div class="w-full md:w-auto">
                <ul class="flex flex-col justify-center -ml-28 space-y-1 md:space-y-6 lg:text-lg md:ml-auto">
                  <li class="flex justify-center items-center"><i class="mr-2 -ml-4 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4 md:-ml-4"></i><span>HTML5</span></li>
                  <li class="flex justify-center items-center"><i class="mr-2 -ml-9 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4 md:-ml-10"></i><span>CSS3</span></li>
                  <li class="flex justify-center items-center"> <i class="mr-2 text-sm fas fa-circle md:text-lg text-secondary lg:mr-4"></i><span>Bootstrap</span></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex relative right-7 flex-col justify-center mt-1 w-1/12 md:mt-10 md:right-3">
            <div
              class="absolute -right-1 bottom-40 w-20 h-24 rounded-tr-3xl border-4 border-b-0 border-l-0 border-secondary md:bottom-8"></div>
            <div
              class="absolute -right-1 top-80 w-20 h-24 rounded-br-3xl border-4 border-t-0 border-l-0 border-secondary md:top-48"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
